import apiService from '../../services/api';

// Init state
const state = {
    items: [],
    item: {},
    listAnalyze: {},
    listDocs: []
};

// Getters
const getters = {
    items: state => state.items
};

// Actions
const actions = {
    getList: (context, params) => {
        return apiService.get('news.index', params).then(response => {
            context.commit('GET_LIST_SUCCESS', response);
            return response;
        });
    },
    updateOrCreate: (context, params) => {
        if (!params.id) {
            return apiService.post('news.index', params).then(response => {
                context.commit('CREATE_SUCCESS', response);
            }
            );
        }
        return apiService.put('news.detail', params).then(response => {
            context.commit('UPDATE_SUCCESS', response);
        });
    },
    delete: (context, params) => {
        return apiService.delete('news.detail', params).then(response => {
            context.commit('DELETE_BY_ID_SUCCESS', params);
        });
    },
    getInfo: (context, params) => {
        return apiService.get('news.detail', params).then(response => {
            context.commit('GET_INFO_SUCCESS', response);
            return response;
        });
    },
    uploadImage(context, params) {
        return apiService.post('file.upload', params);
    },
    getListAnalyze(context, params) {
        return apiService.get('news.analyze', params).then(response => {
            context.commit('GET_ANALYZE', response);
        });
    },
    getViewByNews(context, params) {
        return apiService.get('news.view', params).then(response => {
            return response;
        });
    },
    addViewByNews(context, params) {
        return apiService.post('news.view', params).then(response => {
            return response;
        });
    },
    getListDocs(context, params) {
        return apiService.get('news.document', params).then(response => {
            context.commit('GET_DOCS', response);
        });
    },
    createDoc(context, params) {
        return apiService.post('news.document', params).then(response => {
            context.commit('CREATE_DOCS', response);
        });
    },
    updateDocs(context, params) {
        return apiService.post('news.documentById', params).then(response => {
            context.commit('CREATE_DOCS', response);
        });
    },
    downloadDoc(context, params) {
        return apiService.get('news.document', params).then(response => {
            return response;
        });
    },
    deleteDoc(context, params) {
        return apiService.delete('news.documentById', params).then(response => {
            context.commit('DELETE_DOCS', params);
        });
    }
};

// Mutation
const mutations = {
    GET_LIST_SUCCESS: (state, response) => {
        state.items = response;
    },
    GET_INFO_SUCCESS: (state, response) => {
        state.item = response;
    },
    DELETE_BY_ID_SUCCESS: (state, response) => {
        function findConfigIndex(element) {
            return element.id === response.id;
        }
        const index = state.items.findIndex(findConfigIndex);
        state.items.splice(index, 1);
    },
    CREATE_SUCCESS: (state, response) => {
        state.items.push(response);
    },
    UPDATE_SUCCESS: (state, response) => {
        function findConfigIndex(element) {
            return element.id === response.id;
        }
        const index = state.items.findIndex(findConfigIndex);
        state.items.splice(index, 1, response);
    },
    GET_ANALYZE(state, data) {
        state.listAnalyze = data;
    },
    GET_DOCS(state, data) {
        state.listDocs = data;
    },
    CREATE_DOCS(state, data) {
        state.listDocs.push(data);
    },
    DELETE_DOCS(state, data) {
        const index = state.listDocs.findIndex(item => item.id == data.id);
        state.listDocs.splice(index, 1);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
